export const CATALOG_SHEET_FILE_TYPES = [".xls", ".xlsx", ".xlsm", ".csv"];
